module.exports = __webpack_public_path__ + "static/media/home-main.760e8995.png";